import { createContext } from 'react'

import type { LoginResponse } from '@/types/auth.types'
import type { UserInfo } from '@/types/me.types'
import type { AuthMethod } from '@/utils/tokenManager'

export interface AuthContextType {
  user: UserInfo | null
  isAuthenticated: boolean
  isLoading: boolean
  authMethod: AuthMethod | null
  hasRoles: (roles: string[]) => boolean
  isAdmin: () => boolean
  isManager: () => boolean
  isConsultant: () => boolean
  isAnalyst: () => boolean
  login: (email: string, password: string) => Promise<LoginResponse>
  loginWithEntra: () => Promise<void>
  logout: () => Promise<void>
  refreshToken: () => Promise<void>
  getCurrentUser: () => Promise<UserInfo | null>
  clearSession: () => void
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
